import { httpClient } from '@shared/api'
import type { StatisticsInfoDTO, StatisticsSubInfoDTO } from '../model/types'
import { mapStatisticsFromDTO, mapStatisticsSubFromDTO } from './mappers'
import type { GetStatisticsArgs } from './types'

export const getStatistics = async ({ channel, dateStart, dateEnd }: GetStatisticsArgs) => {
    const { data } = await httpClient.get<StatisticsInfoDTO>(`/stats/posts`, {
        params: {
            channel,
            date_start: dateStart.toISOString(),
            date_end: dateEnd.toISOString()
        }
    })
    return mapStatisticsFromDTO(data)
}

export const getStatisticsSubscribers = async ({ channel, dateStart, dateEnd }: GetStatisticsArgs) => {
    const { data } = await httpClient.get<StatisticsSubInfoDTO>(`/stats/subscribers`, {
        params: {
            channel,
            date_start: dateStart.toISOString(),
            date_end: dateEnd.toISOString()
        }
    })
    return mapStatisticsSubFromDTO(data)
}
